import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { ExaDocumento, ExaDocumentoStato } from '../exa-file/exa-document';

@Injectable()
export class ExaFileValidators {

    validateExaDocument(obbligatorio: boolean = false): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            let doc: ExaDocumento = (<ExaDocumento>control.value);
            if (doc != null) {

                if (doc.stato != ExaDocumentoStato.caricato && doc.stato != ExaDocumentoStato.temporaneo) {
                    return { 'statoInvalid': doc.stato };
                }

                if (obbligatorio && (!doc.idDocumento || doc.idDocumento <= 0)) {
                    return { 'invalidIdDocumento': doc };
                }
            }
            return null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/exa/_validators/exafile-validators.ts